import React from 'react';

const steps = [
  {
    num: '01',
    title: 'We Audit Your Website + Process',
    desc: 'We analyze your current site and workflow to find exactly where you\'re losing leads and time.',
  },
  {
    num: '02',
    title: 'We Identify the Leaks',
    desc: 'Lost leads, slow response gaps, manual tasks — we map every point of friction.',
  },
  {
    num: '03',
    title: 'We Build Your Website + AI System',
    desc: 'A conversion-optimized site and a custom AI automation layer tailored to your business.',
  },
  {
    num: '04',
    title: 'You Get More Clients Automatically',
    desc: 'Your new system handles leads, follow-ups, and bookings — 24/7, without your involvement.',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-32 px-6 w-full" style={{ background: '#061a12' }}>
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-16">
          <p className="text-xs font-mono uppercase tracking-widest mb-4 font-semibold" style={{ color: '#d4f542' }}>The Process</p>
          <h2 className="text-4xl md:text-5xl font-bold text-white tracking-tight">How It Works</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => (
            <div
              key={i}
              className="relative p-8 rounded-2xl flex flex-col"
              style={{ background: '#0c2d1e', border: '1px solid rgba(255,255,255,0.07)' }}
            >
              <span
                className="text-3xl font-bold mb-6 font-mono"
                style={{ color: 'rgba(212,245,66,0.35)' }}
              >
                {step.num}
              </span>
              <h3 className="text-lg font-bold text-white mb-3 leading-tight">{step.title}</h3>
              <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.5)' }}>{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
